import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="landing--how-it-works"
export default class extends Controller {
  connect() {
  }
}
